module.exports = __webpack_public_path__ + "img/step-repeated.9dd694e3.jpg";